"use client";

import React, { useEffect, useState } from "react";
import KeyInfo from "./keyInformation/KeyInfo";
import Insights from "./Insights/Insights";
import PeerComparison from "./peer comparison/PeerComparison";
import AssetAllocation from "./assetAllocation/AssetAllocation";
import OverviewMfGraph from "./OverviewMfGraph";

const MutualFundsRight = ({
  selectedMf,
  keyInfo,
  basicGraph,
  longGraph,
  assetAllocationData,
  peerListData,
  loading,
}) => {
  const [activeButton, setActiveButton] = useState("overview");
  const [MfData, setMfData] = useState(null);

  const res = {
    data: {
      "Parag Parikh Flexi Cap": [
        {
          "2022-12-12": 85.705,
          "2022-12-13": 86.287,
          "2022-12-14": 86.575,
          "2022-12-15": 85.657,
          "2022-12-16": 84.754,
          "2022-12-18": 85.239,
          "2022-12-19": 85.239,
          "2022-12-20": 85.085,
          "2022-12-21": 83.954,
          "2022-12-22": 83.301,
          "2022-12-23": 81.37,
          "2022-12-25": 82.987,
          "2022-12-26": 82.987,
          "2022-12-27": 83.613,
          "2022-12-28": 83.576,
          "2022-12-29": 83.967,
          "2022-12-30": 83.835,
          "2023-01-02": 84.281,
          "2023-01-03": 84.459,
          "2023-01-04": 83.625,
          "2023-01-05": 83.846,
          "2023-01-06": 83.294,
          "2023-01-09": 84.295,
          "2023-01-10": 83.621,
          "2023-01-11": 83.559,
          "2023-01-12": 83.569,
          "2023-01-13": 83.936,
          "2023-01-16": 83.61,
          "2023-01-17": 83.811,
          "2023-01-18": 84.162,
          "2023-01-19": 84.07,
          "2023-01-20": 83.748,
          "2023-01-23": 84.067,
          "2023-01-24": 83.9,
          "2023-01-25": 82.755,
          "2023-01-27": 81.557,
        },
      ],
      "Quant Small Cap Fund": [
        {
          "2022-12-12": 85.705,
          "2022-12-13": 86.287,
          "2022-12-14": 86.575,
          "2022-12-15": 85.657,
          "2022-12-16": 84.754,
          "2022-12-18": 85.239,
          "2022-12-19": 85.239,
          "2022-12-20": 85.085,
          "2022-12-21": 83.954,
          "2022-12-22": 83.301,
          "2022-12-23": 81.37,
          "2022-12-25": 82.987,
          "2022-12-26": 82.987,
          "2022-12-27": 83.613,
          "2022-12-28": 83.576,
          "2022-12-29": 83.967,
          "2022-12-30": 83.835,
          "2023-01-02": 84.281,
          "2023-01-03": 84.459,
          "2023-01-04": 83.625,
          "2023-01-05": 83.846,
          "2023-01-06": 83.294,
          "2023-01-09": 84.295,
          "2023-01-10": 83.621,
          "2023-01-11": 83.559,
          "2023-01-12": 83.569,
          "2023-01-13": 83.936,
          "2023-01-16": 83.61,
          "2023-01-17": 83.811,
          "2023-01-18": 84.162,
          "2023-01-19": 84.07,
          "2023-01-20": 83.748,
          "2023-01-23": 84.067,
          "2023-01-24": 83.9,
          "2023-01-25": 82.755,
          "2023-01-27": 81.557,
        },
      ],
    },
  };

  useEffect(() => {
    if (selectedMf) {
      console.log(selectedMf);
      const data = res.data[selectedMf.mutualfundName] || [];
      //   console.log(res.data[selectedMf.mutualfundName]);
      console.log(data);
      setMfData(data);
    }
  }, [selectedMf]);
  console.log(MfData);

  return (
    <>
      <div className="flex flex-row gap-[10px] h-[42px] border-b border-solid border-[#d9d9d9] sticky top-0 mt-8 mx-4">
        <div className="fle flex-col relative">
          <button
            className={`px-3 py-4 text-sm ${
              activeButton === "overview"
                ? "text-[#00394d] font-semibold"
                : "text-[#262626] font-normal"
            }`}
            onClick={() => setActiveButton("overview")}
          >
            Overview
          </button>
          {activeButton === "overview" && (
            <div className="w-full bg-[#00394d] border-b-4 border-solid border-[#00394d] rounded-full absolute bottom-[-1px]"></div>
          )}
        </div>
        <div className="fle flex-col relative">
          <button
            className={`px-3 py-4 text-sm ${
              activeButton === "Key Information"
                ? "text-[#00394d] font-semibold"
                : "text-[#262626] font-normal"
            }`}
            onClick={() => setActiveButton("Key Information")}
          >
            Key Information
          </button>
          {activeButton === "Key Information" && (
            <div className="w-full bg-[#00394d] border-b-4 border-solid border-[#00394d] rounded-full absolute bottom-[-1px]"></div>
          )}
        </div>
        <div className="fle flex-col relative">
          <button
            className={`px-3 py-4 text-sm ${
              activeButton === "Asset Allocation"
                ? "text-[#00394d] font-semibold"
                : "text-[#262626] font-normal"
            }`}
            onClick={() => setActiveButton("Asset Allocation")}
          >
            Asset Allocation
          </button>
          {activeButton === "Asset Allocation" && (
            <div className="w-full bg-[#00394d] border-b-4 border-solid border-[#00394d] rounded-full absolute bottom-[-1px]"></div>
          )}
        </div>
        <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Peer Comparison"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Peer Comparison")}
        >
          Peer Comparison
        </button>
        {/* <button
          className={`px-3 py-4 text-sm font-normal ${
            activeButton === "Insights"
              ? "border-b-4 border-solid border-[#00394d]  text-sm text-[#00394d] font-semibold"
              : ""
          }`}
          onClick={() => setActiveButton("Insights")}
        >
          Insights
        </button> */}
      </div>
      <div className="h-[calc(100vh-270px)] overflow-y-auto no-scrollbar">
        {activeButton === "overview" ? (
          <>
            {" "}
            <OverviewMfGraph
              basicGraph={basicGraph}
              longGraph={longGraph}
              loading={loading}
            />
            <KeyInfo keyInfo={keyInfo} />
            <AssetAllocation assetAllocationData={assetAllocationData} />
            <PeerComparison peerListData={peerListData} />
          {/* <Insights /> */}
          </>
        ) : activeButton === "Key Information" ? (
          <>
            <KeyInfo keyInfo={keyInfo} />
          </>
        ) : activeButton === "Asset Allocation" ? (
          <>
            <AssetAllocation assetAllocationData={assetAllocationData} />
          </>
        ) : activeButton === "Peer Comparison" ? (
          <>
            <PeerComparison peerListData={peerListData} />
          </>
        ) : activeButton === "Insights" ? (
          <>
            <Insights />
          </>
        ) : null}
      </div>
    </>
  );
};

export default MutualFundsRight;
